import { IPage } from 'common/models';
import { ICancellationPolicyRoot } from 'modules/settings/models';
import API from 'services/api';

export const getCancellationPoliciesRoot = (): Promise<IPage<ICancellationPolicyRoot>> => {
  return API.get(`/api/root/cancellation-policy?PageNo=1&PageSize=1000`).then(res => res?.data);
};
